<template>
  <v-form class="subscribe-form"
          @submit.prevent="onSubmitForm"
          ref="form"
          v-focusInvalidInput
          v-model="valid"
          :lazy-validation="lazy">

      <div v-for="(field) in fields" :key="field.id">
          <v-text-field
              v-if="field.type === 'textField'"
              outlined
              required
              v-model="field.model"
              :label="field.label"
              :rules="field.rules"
              :aria-labelledby="`${field.id}Error`">
              <span slot="message" :id="`${field.id}Error`" slot-scope="{key,message}">{{ message }}</span>
          </v-text-field>
          <v-checkbox
              v-if="field.type === 'checkbox'"
              class="d-inline-block ma-0 pa-0"
              false-value="0"
              true-value="1"
              :label="field.label">

          </v-checkbox>
      </div>

    <div class="text-center">
      <v-btn class="submit mb-5 is-valid"
             type="submit"
             color="secondary"
             x-large
      >
        Submit
      </v-btn>
    </div>

      <vue-recaptcha :loadRecaptchaScript="false"
                     @expired="onExpired"
                     @verify="onVerify"
                     ref="invisibleRecaptcha"
                     sitekey="6LcjTiYUAAAAAJVJ8T-5FLapLUhNYZVwV3Ov-ewD"
                     size="invisible"></vue-recaptcha>

  </v-form>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {SubscribeDataModel} from '@/models/request/SubscribeData.model';
import VueRecaptcha from 'vue-recaptcha';
import {outbrainClient} from "../repositories/Repositories";
import {DEFAULT_SUBSCRIBE_DATA} from "@/data/subscribe";

@Component({
        components: {
            VueRecaptcha
        }
    })
    export default class SubscribeForm extends Vue {

        private valid: boolean = false;
        private subscribeData: SubscribeDataModel = Object.assign({}, DEFAULT_SUBSCRIBE_DATA);
        private recaptchaResponse: string = '';

        private nameRules = [
            (v: any) => !!v || 'Name is required',
            (v: any) => (v && v.length <= 30) || 'Name must be less than 30 characters',
            (v: any) => /^[a-zA-Z\s]+$/.test(v) || 'Name is not valid!',
        ];
        private emailRules = [
            (v: any) => !!v || 'E-mail is required',
            (v: any) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ];

        private required = [
            (v: any) => !!v || 'This field is required',
        ];

    private readonly fields =[
        {id:'FirstName',type:'textField',model:this.subscribeData.first_name,label:'First Name',rules: this.nameRules},
        {id:'LastName',type:'textField',model:this.subscribeData.last_name,label:'Last Name',rules: this.nameRules},
        {id:'Email',type:'textField',model:this.subscribeData.email,label:'E-mail',rules: this.emailRules},
        {id:'JobTitle',type:'textField',model:this.subscribeData.title,label:'Job title',rules:this.required},
        {id:'Company',type:'textField',model:this.subscribeData.company,label:'Company',rules:this.required},
        {id:'ProductUpdates',type:'checkbox',model:this.subscribeData.consent,label:'Yes! Send me product updates, insights, tips and more.'},
        {id:'NativeSpeakingExpert',type:'checkbox',model:this.subscribeData.expert,label:'Open to speaking to a Native Ads expert.'}
    ]


    lazy: boolean = false;

        created() {
            let reCaptchaScript = document.createElement('script');
            reCaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?hl=iw&onload=vueRecaptchaApiLoaded&render=explicit');
            reCaptchaScript.setAttribute('async', 'true');
            reCaptchaScript.setAttribute('defer', 'true');
            document.head!.appendChild(reCaptchaScript);
        }

        mounted() {
        }

        onSubmitForm() {
            this.form.validate()
            if (this.valid && this.$refs.invisibleRecaptcha) {
                (this.$refs.invisibleRecaptcha as any).execute();
            }
        }

        onVerify(response: any) {
            this.subscribeData.token = response;
            if (response) {
                this.resetRecaptcha();
                this.submit();
                this.reset();
            }

        }

        onExpired() {
            console.log('Expired');
        }

        resetRecaptcha() {
            setTimeout(() => {
                if (this.$refs.invisibleRecaptcha) {
                    (this.$refs.invisibleRecaptcha as any).reset(); // Direct call reset method
                }
            }, 1000);

        }

        get form(): Vue & { validate: () => boolean, reset: () => boolean } {
            return this.$refs.form as Vue & { validate: () => boolean, reset: () => boolean, resetValidation: () => boolean };
        }

        reset() {
            this.form.reset();
        }

        private submit() {
            this.$emit('submitForm', {...this.subscribeData,});
            const payload = {...this.subscribeData, "g-recaptcha-response": this.subscribeData.token};
            outbrainClient.post('/service/contact', payload).then((res: any) => console.debug(res));
        }

    }

</script>

<style scoped lang="scss">
  .subscribe-form {
    .submit {
      width: 100px;
      margin-bottom: 5px;
      font-size: 18px;
      text-transform: capitalize;

      &.is-valid {
        width: 100%;
        font-weight: bold;
      }

    }

    .warning--text {
      color: initial !important;
      caret-color: initial !important;
    }

    .error--text {
      color: initial !important;
      caret-color: initial !important;
    }

    .v-text-field {
      margin-bottom: 7px;

    }

  }

</style>
